module.exports = __webpack_public_path__ + "static/media/TZ.ec5a26d3.svg";